import { Icon } from '@iconify/react'
import { Tooltip } from 'antd'
import type { IntakeTemplateItem } from 'features/Procedure/state/procedure-api.type'

import styles from './signed-documents.module.scss'

type ColumnsParams = {
  onSign: (template: IntakeTemplateItem) => void
  disableActions?: boolean
}

export const intakeTemplatesColumns = ({ onSign, disableActions = false }: ColumnsParams) => [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    width: 56,
    render: (_: unknown, template: IntakeTemplateItem) => (
      <Tooltip title='Sign document'>
        <button
          className={styles.signButton}
          onClick={() => onSign(template)}
          disabled={disableActions}>
          <Icon icon='mdi:sign' width={20} height={20} color='var(--primary-20)' />
        </button>
      </Tooltip>
    ),
  },
  {
    title: 'Document',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
]
